{
	"en": {
		"account": {
			"suspended": {
				"lineOne": "Your organization's CareAcademy subscription has a billing issue.",
				"lineTwo": "Your account access has been suspended. Contact your billing manager for more information.",
				"title": "Account access suspended"
			}
		},
		"constants": {
			"incorrectMember": "Incorrect team member. Please contact organization for more information."
		},
		"footer": {
			"copyWrite": "&copy; {{year}} CareAcademy. All rights reserved",
			"medicalDisclaimer": "Medical Disclaimer",
			"privacyPolicy": "Privacy Policy",
			"termsOfService": "Terms of Service"
		},
		"global": {
			"add": "add",
			"agencies": "organizations",
			"agency": "organization",
			"button": {
				"continue": "Continue",
				"getStarted": "Get started",
				"goBack": "Go back"
			},
			"certificate": "certificate",
			"certificates": "certificates",
			"class": "class",
			"classes": "classes",
			"complete": "complete",
			"completed": "completed",
			"completedDate": "completed date",
			"due": "due",
			"dueOn": "due on",
			"login": "Sign in",
			"logout": "Sign out",
			"needHelp": "Need help?",
			"noItems": "No items",
			"notAvailable": "N/A",
			"select": "select",
			"status": {
				"complete": "complete",
				"completed": "completed"
			},
			"training": {
				"annual": "annual",
				"annualTraining": "annual training",
				"initial": "initial",
				"initialTraining": "initial training",
				"none": "none",
				"training": "training"
			}
		},
		"member": {
			"continuingEducation": {
				"changeMessage": "Change this CNA's <i>Language</i> to English if you want their classes to be eligible for CE credit.",
				"requirementMessage": "The state of California <u>requires</u> that all Certified Nursing Assistants (CNAs) must complete classes in English to receive continuing education (CE) credit.",
				"title": "Continuing Education Credits for CNAs"
			}
		},
		"memberDashboard": {
			"agencyListing": {
				"active": "Your <span>{{nameOfTraining}}</span> is due on <span class='fw4-ns'>{{dueDate}}</span>",
				"inactive": {
					"lineOne": "You have been deactivated by this organization.",
					"lineTwo": "Please contact the organization for more information."
				},
				"suspended": {
					"lineOne": "Your account access has been suspended.",
					"lineTwo": "Please contact your supervisor for more information."
				}
			},
			"agencyTraining": {
				"noTraining": {
					"assignedTraining": "Assigned training may take time to process before it appears on your dashboard.",
					"subtitle": "You have not been enrolled in any training."
				},
				"title": "What's <span>next</span>"
			},
			"button": {
				"add": "Add",
				"enroll": "Enroll",
				"processing": "Processing",
				"resetExam": "Reset Exam",
				"viewCertificates": "View certificates",
				"viewAllClasses": "View all classes",
				"yourAgencies": "Your organizations",
				"yourCertificates": "Your certificates",
				"videoLibrary": "Self-serve video library"
			},
			"classDetails": {
				"courseCallout": {
					"class": "{{count}} class",
					"classes": "{{count}} classes",
					"minutes": "{{duration}} minutes"
				},
				"dueDateCallout": "To comply with the state regulations, you must complete this class within {{days}} days of starting it.",
				"getStarted": "Get started",
				"nextClass": "next class",
				"noCourses": "Check back soon for additional courses"
			},
			"dashboardHeader": {
				"completedTraining": "You have <span>completed</span> all your assigned training!",
				"dueOn": "Due: <span class='dynamic-column-header__primary-text'>{{trainingDueDate}}</span>"
			},
			"landingPage": {
				"listOfTraining": "Below is a list of your <span class='dynamic-column-header__secondary-text'>organizations</span>.<br /><br /><span class='dynamic-column-header__secondary-text'>Select an organization</span> to continue your training.</p>",
				"title": "Hi <span class='dynamic-column-header__secondary-text'>{{firstName}}</span>!"
			},
			"optionalTraining": {
				"button": "I understand",
				"confirmation": "Sounds good? Let's do this!",
				"message": "This is optional training that was not assigned by your organization. You have free access to this training because your organization uses <span class='brand-name brand-name--alternate'><span class='brand-primary-text'>Care</span><span class='brand-secondary-text'>Academy</span></span>. Check with your supervisor directly for compensation policies about optional training.",
				"title": "Ready to level up your skills?<br />Way to go!"
			},
			"placeholder": {
				"text": "Go to LearnUpon"
			},
			"title": "Member Dashboard",
			"trainingWithDueDate": {
				"learn": "learn something new",
				"trainingDueOn": "Due: <span class='member-dashboard__highlight'>{{goalDueDate}}</span>"
			},
			"trainingCompletionContent": "You've completed <span class='dynamic-column-header__secondary-text'>{{completedCourseStatusesCount}} of {{courseStatusesCount}} classes</span> towards your <span class='dynamic-column-header__secondary-text'>{{nameOfTraining}}</span> for <span class='dynamic-column-header__ternary-text'>{{agencyName}}</span>",
			"trainings": {
				"nextRequiredClass": "<span>Select a training</span> below to view more details.",
				"selfEnroll": "Select the <svg class=\"svg-component SVGPlusCircle\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" stroke-width=\"1.5\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z\" /></svg> icon to add more training",
				"title": "All your <span>training</span>"
			}
		},
		"printCertificates": {
			"completeClasses": "Certificates will appear here once you complete classes.",
			"noCertificates": "No certificates found.",
			"title": "Print Certificates for Classes"
		},
		"selfEnrollment": {
			"additionalTraining": {
				"checkBack": "Check back soon for new <span class='brand-name'><span class='brand-primary-text'>Care</span><span class='brand-secondary-text'>Academy</span></span> training programs",
				"subtitle": "You have completed all of the <span>new training</span> that is currently available.",
				"title": "Additional training"
			},
			"button": {
				"addMoreTraining": "Add more training",
				"enroll": "Enroll",
				"goToDashboard": "Go to dashboard",
				"processing": "Processing",
				"returnToDashboard": "Return to dashboard"
			},
			"enrollmentInProgress": {
				"currentlyProcessing": "We are enrolling you in {{trainingName}}! Once complete, you will see the {{trainingName}} training listed in the 'All your training' section of your team member dashboard.",
				"title": "Enrollment in progress"
			},
			"placeholder": {
				"incorrectMember": "Incorrect team member. Please contact organization for more information.",
				"title": "No items"
			},
			"subtitle": "Select <span>enroll</span> to add a training program to your dashboard.",
			"title": "Available <span>training</span>"
		}
	}
}
